export default __webpack_public_path__ + "static/media/MascotaSegura.38239ef2.svg";